import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { getByIdCurrency, updateCurrency } from "store/currency/currency-action"
import CurrencyForm from "components/Currencies/form"
import { currencyAction } from "store/currency/currency-slice"
import Preloader from "components/Common/Loader"

const EditCurrency = () => {
  document.title = "Edit Currency"

  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, currency, error } = useSelector(state => state.currency)

  const onSubmit = values => {
    values.id = id
    dispatch(updateCurrency(id, values, navigate))
  }

  useEffect(() => {
    dispatch(getByIdCurrency(id))

    return () => {
      dispatch(currencyAction.resetState())
    }
  }, [])

  return (
    <React.Fragment>
      {currency ? (
        <CurrencyForm
          loading={loading}
          currency={currency?.data}
          error={error}
          onSubmit={onSubmit}
          formMode={"Edit"}
        />
      ) : (
        <Preloader loading={true} />
      )}
    </React.Fragment>
  )
}

export default EditCurrency
